// extracted by mini-css-extract-plugin
export default {"header":"Header_header__E1ZSI","container":"Header_container__xqR3L","navDesktop":"Header_navDesktop__fv+uN","mobileToggle":"Header_mobileToggle__kzc1P","bar":"Header_bar__WY26l"};